import React from 'react';
import { Typography } from '@mui/material';

const BaseHeader = ({ children, sx = {}, ...rest }) => {
  return (
    <Typography
      sx={{
        fontFamily: 'Playfair Display, serif',
        background: 'linear-gradient(160deg, #ac3288ff 0%, #d44faa 45%, #6f1158ff 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontSize: '5rem',
        letterSpacing: '0.05em',
        filter: 'drop-shadow(0 0 5px rgba(177, 39, 135, 0.36))',
        marginBottom: '1rem',
        textAlign: 'center',
        paddingTop: '30px',
        ...sx, // Allow for overrides
      }}
      {...rest}
    >
      {children}
    </Typography>
  );
};

export default BaseHeader;